import { HiChevronRight, HiChevronLeft } from 'react-icons/hi2'

export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
	const getPaginationRange = () => {
		const range = []
		const startPage = Math.max(1, currentPage - 2)
		const endPage = Math.min(totalPages, currentPage + 2)

		for (let i = startPage; i <= endPage; i++) {
			range.push(i)
		}

		return range
	}

	return (
		<div className='tw-flex tw-items-center tw-justify-center mt-4 tw-text-gray-600'>
			<button
				className={`tw-h-[35px] tw-w-[42px] tw-px-3 tw-py-1 tw-mx-1 border tw-rounded-md tw-flex tw-items-center tw-gap-4 ${
					currentPage === 1 ? 'tw-bg-gray-200 tw-cursor-not-allowed' : 'tw-bg-white hover:tw-bg-purple-100'
				}`}
				onClick={() => onPageChange(currentPage - 1)}
				disabled={currentPage === 1}
			>
				<HiChevronLeft />
			</button>

			{getPaginationRange().map(page => (
				<button
					key={page}
					className={`tw-h-[35px] tw-w-[42px] tw-px-3 tw-py-1 tw-mx-1 border tw-rounded-md ${
						page === currentPage ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-white hover:tw-bg-purple-100'
					}`}
					onClick={() => onPageChange(page)}
				>
					{page}
				</button>
			))}

			<button
				className={`tw-h-[35px] tw-w-[42px] tw-px-3 tw-py-1 tw-mx-1 border tw-rounded-md tw-flex tw-items-center tw-gap-4 ${
					currentPage === totalPages ? 'tw-bg-gray-200 tw-cursor-not-allowed' : 'tw-bg-white hover:tw-bg-purple-100'
				}`}
				onClick={() => onPageChange(currentPage + 1)}
				disabled={currentPage === totalPages}
			>
				<HiChevronRight />
			</button>
		</div>
	)
}
